export default __webpack_public_path__ + "static/media/doctors-1.eec585aa.jpg";